exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.busy-wait-time-link[data-v-75126c72] {\n    transition: -webkit-text-decoration 0.2s;\n    transition: text-decoration 0.2s;\n    transition: text-decoration 0.2s, -webkit-text-decoration 0.2s;\n}\n.busy-wait-time-link[data-v-75126c72]:hover {\n    text-decoration: underline;\n}\n", ""]);

// exports
